import React, { createContext, useState } from "react";

//create the context
export const NotiContext = createContext<any>(undefined);

export const NotiProvider : React.FC = ({ children }) => {

	const [msg, setMsg] = useState(0);
	const [noti, setNoti] = useState(0);
  
	let state = {
		msg,
		setMsg,
		noti,
		setNoti
	};

  //wrap the application in the provider
  return <NotiContext.Provider value={state}>{children}</NotiContext.Provider>;
};

export default NotiContext;